import React from 'react';

const StudentDetailPage = React.lazy(() => import('./StudentDetailPage'));

const StudentDetailConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/billing/students/:studentId',
			element: (
				<React.Suspense fallback={<>...</>}>
					<StudentDetailPage />
				</React.Suspense>
			),
		},
		{
			path: '/billing/students/:studentId/:tab',
			element: (
				<React.Suspense fallback={<>...</>}>
					<StudentDetailPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default StudentDetailConfig;
